import type { fabric } from 'fabric';
import type { FabricEditor } from 'modules/fabric-editor';
import { useCallback, useEffect, useState } from 'react';

export function useFabricProp<T>(
  object: fabric.Object,
  key: string,
  editor: FabricEditor,
): [T, (value: T) => void] {
  const read = useCallback(() => (object as unknown as Record<string, T>)[key], [object, key]);
  const [value, setValue] = useState<T>(read);

  useEffect(() => {
    setValue(read());
    const off = editor.on('object:modified', (e) => {
      if (e.target === object) setValue(read());
    });
    return () => off();
  }, [editor, object, read]);

  const update = useCallback(
    (next: T) => {
      editor.objects.setProp(object, key as keyof fabric.Object, next as never);
      setValue(next);
    },
    [editor, object, key],
  );

  return [value, update];
}
